import api from './api';

const leadsWebApi = {
  // Récupérer tous les leads (avec filtres optionnels)
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.statut) params.append('statut', filters.statut);
    if (filters.priorite) params.append('priorite', filters.priorite);
    if (filters.type_vehicule) params.append('type_vehicule', filters.type_vehicule);
    if (filters.vendeur_id) params.append('vendeur_id', filters.vendeur_id);
    if (filters.concession_id) params.append('concession_id', filters.concession_id);
    if (filters.actifs) params.append('actifs', '1');
    
    return api.get(`/leads-web?${params.toString()}`);
  },

  // Récupérer un lead par ID
  getById: (id) => api.get(`/leads-web/${id}`),

  // Créer un nouveau lead
  create: (leadData) => api.post('/leads-web', leadData),

  // Modifier un lead
  update: (id, leadData) => api.put(`/leads-web/${id}`, leadData),

  // Supprimer un lead
  delete: (id) => api.delete(`/leads-web/${id}`),

  // Suppression en masse
  bulkDelete: (ids) => api.post('/leads-web/bulk-delete', { ids }),

  // Mise à jour en masse
  bulkUpdate: (ids, data) => api.post('/leads-web/bulk-update', { ids, data }),

  // Récupérer les commentaires d'un lead
  getCommentaires: (leadId) => api.get(`/leads-web/${leadId}/commentaires`),

  // Historique des modifications d'un lead (qui, quand, quoi)
  getHistorique: (leadId) => api.get(`/leads-web/${leadId}/historique`),

  // Ajouter un commentaire
  addCommentaire: (leadId, commentaireData) => 
    api.post(`/leads-web/${leadId}/commentaires`, commentaireData),

  // Récupérer les statistiques
  getStats: () => api.get('/leads-web/stats/overview'),

  // Statistiques dashboard (non assignés)
  getDashboardStats: (params) => api.get('/leads-web/stats/dashboard', params ? { params } : undefined),

  // Leads par source × par jour (tableau de bord mensuel)
  getStatsByJour: (mois, annee, concession_id, campagne_id, service) =>
    api.get('/leads-web/stats/par-jour', { params: {
      ...(mois          ? { mois }          : {}),
      annee,
      ...(concession_id ? { concession_id } : {}),
      ...(campagne_id   ? { campagne_id }   : {}),
      ...(service       ? { service }       : {}),
    } }),

  // Suivi collaborateurs (super-admin)
  getSuiviCollaborateurs: (params) => api.get('/leads-web/suivi-collaborateurs', params ? { params } : undefined),

  // Transformer un lead web en demande client
  transformToDemande: (id, payload) => api.post(`/leads-web/${id}/transform-to-demande`, payload),

  // ─── Configuration vendeurs (marques autorisées + flag absent) ──────────
  // Accès : super-admin OU users.is_manager. Manager voit ses subordonnés.
  getConfigTeam: () => api.get('/leads-web/config/team'),
  setVendeurMarques: (userId, type_lead, marques) =>
    api.put(`/leads-web/config/team/${userId}/marques`, { type_lead, marques }),
  setVendeurAbsent: (userId, absent) =>
    api.put(`/leads-web/config/team/${userId}/absent`, { absent }),

  // ─── CRM360 : import des statuts + funnel de vente ──────────────────────
  importCrm360: (formData) =>
    api.post('/leads-web/crm360/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getCrm360Imports: () => api.get('/leads-web/crm360/imports'),
  getCrm360ImportRows: (id, match) =>
    api.get(`/leads-web/crm360/imports/${id}/rows`, { params: match ? { match } : {} }),
  getFunnel: (params = {}) => api.get('/leads-web/crm360/funnel', { params }),
};

export default leadsWebApi;